import axios from "axios";
import appconst from "./appConst";
import Vue from "vue";
import Util from "@/lib/util";

class AjaxFactory {
    create(serviceName: string = "") {
        const ajax = axios.create({
            baseURL: appconst.remoteServiceBaseUrl + `/${serviceName}`,
            timeout: 30000,
        });

        ajax.interceptors.request.use(
            function (config) {
                config.headers.common["Authorization"] =
                    "Bearer " + Util.abp.auth.getToken();
                config.headers.common[".AspNetCore.Culture"] =
                    window.abp.utils.getCookieValue(".Localization.CultureName");
                config.headers.common["TenantId"] =
                    window.abp.multiTenancy.getTenantIdCookie();
                // config.headers.common["TenantId"]=window.abp.multiTenancy.getTenantIdCookie();
                return config;
            },
            function (error) {
                return Promise.reject(error);
            }
        );

        const vm = new Vue({});
        ajax.interceptors.response.use(
            (respon) => {
                return respon;
            },
            (error) => {
                let systemTips = window.abp.localization.localize(
                    "SystemTips",
                    appconst.localization.defaultLocalizationSourceName
                );

                if (systemTips === "SystemTips") {
                    systemTips = "温馨提示";
                }

                if (
                    !!error.response &&
                    !!error.response.data.error &&
                    !!error.response.data.error.message &&
                    error.response.data.error.details
                ) {
                    vm.$Modal.error({
                        title: error.response.data.error.message,
                        content: error.response.data.error.details,
                    });
                } else if (
                    !!error.response &&
                    !!error.response.data.error &&
                    !!error.response.data.error.message
                ) {
                    vm.$Modal.error({
                        title: systemTips,
                        content: error.response.data.error.message,
                        onOk: () => {
                            localStorage.setItem("LoginReturnUrl", window.location.href);
                        },
                    });
                } else if (!error.response) {
                    // vm.$Modal.error({
                    //     title: systemTips,
                    //     content: '系统开小差，请稍后重试',
                    //     onOk: () => {
                    // 系统开小差，请稍后重试

                    // 生产环境下自动刷新
                    if (location.href.indexOf("localhost") === -1) {
                        setTimeout(() => {
                            location.reload();
                        }, 5000);
                    }

                    // }
                    // });
                } else {
                    if (error.toString().indexOf("status code 401") > -1) {
                        vm.$Modal.error({
                            title: systemTips,
                            content: window.abp.localization.localize(
                                "SessionTimeout",
                                appconst.localization.defaultLocalizationSourceName
                            ),
                            onOk: () => {
                                Util.abp.auth.clearToken();
                                localStorage.setItem("LoginReturnUrl", window.location.href);
                                location.href = "/login";
                            },
                        });
                    } else {
                        vm.$Modal.error({
                            title: systemTips,
                            content: window.abp.localization.localize(
                                "UnknownError",
                                appconst.localization.defaultLocalizationSourceName
                            ),
                        });
                    }
                }

                setTimeout(() => {
                    vm.$Message.destroy();
                }, 1000);

                return Promise.reject(error);
            }
        );

        return ajax;
    }
}

export default AjaxFactory;
